<template>
  <div class="refund-deposit">
    <p :class="[{'required-flag': canUpdate}, 'blod-p', {'noBegin': !isBegin && isEngineer}]">
      {{ $t('tenantProjects.refundAmount') }}
    </p>
    <div
      v-if="isTenant"
      class="subject-to-review"
    >
      <span
        v-if="!notifyAccountingInfo"
        class="medium-size"
      >
        {{ $t('tenantProjects.subjectToReview') }}
      </span>
      <div v-else>
        <span class="medium-size margin-right-15">{{ currency }} <span class="blod-p">{{ showAmount }}</span></span>
        <i class="gray-font vertical-middle">{{ $t('tenantProjects.defuctedAmount') }} {{ currency }} {{ defuctedAmount }}</i>
      </div>
      <div
        v-if="isTenancyOrNormalAccount"
        class="btns"
      >
        <template
          v-if="isUserNotifyAccounting"
        >
          <button
            v-if="reEditAble"
            class="btn btn--darkblue margin-right-15"
            @click="cancelChangeRefundRequest"
          >{{ $t('action.cancel') }}</button>
          <button
            v-if="!requested || reEditAble"
            :class="['btn--darkblue btn']"
            @click="requestToRefundModal"
          >{{ $t('tenantProjects.requestRefund') }}</button>
          <button
            v-if="requested && !reEditAble"
            :class="['btn--darkblue btn']"
            :disabled="disabledChangeRefundRequest"
            @click="changeRefundRequest"
          >{{ $t('tenantProjects.changeRefundRequest') }}</button>
        </template>
        <i
          v-if="showRequestedBy && showRequestedAt"
          class="gray-font"
        >
          {{ $t('tenantProjects.lastRequestByOn',[showRequestedBy, showRequestedAt]) }}
        </i>
        <i
          v-if="requested && !notAvaliableFinalDoc && !canChangeRefundRequest"
          class="gray-font request-refund-info"
          v-html="$t('tenantProjects.requestRefundInfo')"
        />
      </div>
    </div>
    <div
      v-else
      class="btns"
    >
      <button
        v-if="canResumeRefundRequest && !notAvaliableFinalDoc"
        class="btn btn--darkblue margin-left-15"
        @click="resumeRefundRequest"
      >{{ $t('tenantProjects.resumeRefundRequest') }}</button>
      <button
        v-if="canUpdate && !canNotifyAccounting"
        class="btn btn--darkblue margin-left-15"
        :disabled="!isBegin || !isFinalDocsValid"
        @click="notifyPM"
      >{{ $t('tenantProjects.notifyPM') }}</button>
      <button
        v-if="canNotifyAccounting"
        class="btn btn--darkblue margin-left-15"
        :disabled="!isBegin || !isFinalDocsValid"
        @click="openModal"
      >{{ $t('tenantProjects.notifyAccounting') }}</button>
      <div class="deposit-notify-info">
        <i
          v-if="notifyPMInfo && canUpdate"
          class="gray-font"
        >
          {{ $t('tenantProjects.notifyPMByAt', [notifyPMInfo.by, notifyPMInfo.time]) }}
        </i>
        <i
          v-if="notifyAccountingInfo"
          class="gray-font"
        >
          {{ $t('tenantProjects.notifyAccountingByAt', [notifyAccountingInfo.by, notifyAccountingInfo.time]) }}
        </i>
        <i
          v-if="resumeRefundRequestInfo"
          class="gray-font"
        >
          {{ $t('tenantProjects.resumeRefundRequestByAt', [resumeRefundRequestInfo.by, resumeRefundRequestInfo.time]) }}
        </i>
      </div>
    </div>
    <div
      v-if="isEngineer"
      :class="['refund-user-input', {'noBegin': !isBegin}]"
    >
      <div class="deducted-amount">
        <span>{{ currency }}</span>
        <InputField
          :readonlyAsInput="!isBegin || (isNotifiedPM && !isEditingAmount)"
          :class="['input-deducted-amount', { 'error-highlight-input': refundAmountError }]"
          :readonly="!canUpdate"
          :placeholder="'0.00'"
          :showColon="false"
          :showFlag="false"
          :value="amount"
          :inputCheckType="'decimal'"
          :pattern="regex.decimal"
          :patternOnly="validateRefundAmountInput"
          :inputTip="hintValue"
          :required="true"
          :parentNode="FORM_SRC_PROJECT_CONTROL"
          @updateValue="val => updateAmount(val)"
        />
        <i
          v-show="isNotifiedPM && !isEditingAmount && canUpdate"
          class="fa fa-pencil"
          @click="isEditingAmount = true"
        />
        <span class="deducted-amount-hint">
          <span>{{ $t('tenantProjects.defuctedAmount') }} {{ currency }}</span>
          {{ defuctedAmount }}
        </span>
      </div>
      <div class="credit-to">
        <p :class="[{'required-flag': canUpdate}, 'blod-p']">
          {{ $t('tenantProjects.creditTo') }}
        </p>
        <div class="input-credit-to-pencil">
          <InputField
            :readonlyAsInput="!isBegin || (isNotifiedPM && !isEditingAmount) || isAmountZero"
            class="input-credit-to"
            :readonly="!canUpdate"
            :showColon="false"
            :showFlag="false"
            :value="creditTo"
            :required="!isAmountZero"
            :placeholder="$t('tenantProjects.plsInputAccountCode')"
            :parentNode="FORM_SRC_PROJECT_CONTROL"
            @updateValue="val => updateCreditTo(val)"
          />
          <i
            v-show="isNotifiedPM && !isEditingAmount && canUpdate"
            class="fa fa-pencil"
            @click="isEditingAmount = true"
          />
        </div>
      </div>
      <div class="payee-info">
        <p :class="[{'required-flag': isTenant}, ' blod-p']">
          {{ $t('tenantProjects.payeeInfo') }}
        </p>
        <i
          v-if="showRequestedBy && showRequestedAt"
          class="gray-font"
        >
          {{ $t('tenantProjects.lastRequestByOn',[showRequestedBy, showRequestedAt]) }}
        </i>
        <div v-if="!isBegin">
          --
        </div>
        <div
          v-else-if="!isDirect"
          class="payee-area"
        >
          <p class="blod-p">
            {{ $t('tenantProjects.payeeName') }}
          </p>
          <span class="medium-size">{{ payeeName || '--' }}</span>
          <p class="blod-p">
            {{ $t('tenantProjects.mailingAddr') }}
          </p>
          <pre class="medium-size">{{ address || '--' }}</pre>
        </div>
        <p v-else>
          {{ $t('tenantProjects.directToTenant') }}
        </p>
      </div>
    </div>
    <div
      v-else-if="isUserNotifyAccounting && (!requested || reEditAble) && isTenancyOrNormalAccount"
      class="tenant-edit-area"
    >
      <div class="payee-info">
        <p class="required-flag blod-p">
          {{ $t('tenantProjects.payeeInfo') }}
        </p>
        <div>
          <input
            v-model="isDirect"
            type="radio"
            :value="true"
            @click="changePayeeType"
            @change="scheduleDirtyStateCheck"
          >
          <span>{{ $t('tenantProjects.directToTenant') }}</span>
        </div>
        <div>
          <input
            v-model="isDirect"
            type="radio"
            :value="false"
            @change="scheduleDirtyStateCheck"
          >
          <span>{{ $t('tenantProjects.otherPayee') }}</span>
        </div>
      </div>
      <InputField
        v-if="!isDirect"
        class="payee-name"
        :showColon="false"
        :label="$t('tenantProjects.payeeName')"
        :value="payeeName"
        :required="true"
        :parentNode="FORM_SRC_PROJECT_CONTROL"
        @updateValue="val => updatePayeeName(val)"
      />
      <TextField
        v-if="!isDirect"
        class="mailing-address"
        :showColon="false"
        :label="$t('tenantProjects.mailingAddr')"
        :value="address"
        :inputTip="hintString"
        :required="true"
        :parentNode="FORM_SRC_PROJECT_CONTROL"
        @updateValue="val => updateAddress(val)"
      />
    </div>
    <div
      v-else-if="isUserNotifyAccounting"
      class="refund-view"
    >
      <p class="blod-p">
        {{ $t('tenantProjects.payeeInfo') }}
      </p>
      <span v-if="isDirect">{{ $t('tenantProjects.directToTenant') }}</span>
      <div v-else>
        <span>{{ $t('tenantProjects.otherPayee') }}</span>
        <p class="blod-p">
          {{ $t('tenantProjects.payeeName') }}
        </p>
        <span class="medium-size">{{ payeeName }}</span>
        <p class="blod-p">
          {{ $t('tenantProjects.mailingAddr') }}
        </p>
        <pre class="medium-size">{{ address }}</pre>
      </div>
    </div>

    <Modal
      ref="refund-input-modal"
      modalType="small-modal"
      class="refund-input-modal"
      :showCloseBtn="false"
      modalId="refund-input-modal"
    >
      <p
        slot="content"
        class="font-bold"
      >
        {{ $t('tenantProjects.inputAccountingHint') + ' ' }}
        <span>{{ accountingEmail || '--' }}</span>
      </p>
      <div slot="btns">
        <button
          class="btn--darkblue"
          @click="closeModal"
        >{{ $t('action.cancel') }}</button>
        <button
          class="btn--orange"
          @click="sendEmailToAccounting"
        >{{ $t('action.send') }}</button>
      </div>
    </Modal>
    <RequestRefundConfirmModal
      ref="confirmRef"
      @onOkClick="requestToRefund"
    />
  </div>
</template>

<script>
import CurrencyFormatter from 'currency-formatter'
import lodash from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import { computed, unref, getCurrentInstance } from 'vue-demi'
import Modal from '@/controls/Modal'
import InputField from '@/controls/InputField'
import TextField from '@/controls/TextField'
import * as regex from '@/utils/regex'
import * as tenantProjectApi from '@/api/tenantProjects/request'
import dateUtil from '@/utils/dateUtil'
import { EmailTypes } from '@/utils/consts'
import { fusionInputCheckUtil } from '@/plugin/FusionInputCheck'
import { buildEmails, sendEmail } from '@/api/postman/request'
import { getRegionEnvsByCode } from '@/api/settings/request'
import { utils as formUtils } from '@/plugin/InputChange'
import i18n from '@/utils/i18n'
import notification from '@/utils/notification'
import { replaceDisplayName } from '@/modules/tenantProjects/utils'
import { FINAL_DOC_STATUS } from '@/modules/tenantProjects/consts'
import { useRefModal } from '@/controls/Modal/modal.hook'
import { aclHelper, tmsPermsTypes } from '@/utils/aclHelper'
import { tenantProjectStatus } from '@/utils/locale'
import { useFinalDocStatus } from '../FinalDocuments/hook'
import { useStoreGetters } from '../../../../store'
import { useIsCurrentTenantProjectStatus } from '../../hook'
import { useFinalDocLength } from '../hook'
import { DEPOSIT_HISTORY_TYPE } from './consts'
import RequestRefundConfirmModal from './RequestRefundConfirmModal'
import { validateProjectControlFieldsOnLoad } from '../fieldValidationOnLoad'
import { FORM_SRC_PROJECT_CONTROL } from '../consts'
import { buildRefundNotifyAccountingEmailPayload, buildDirtyFieldSaveRequest, getLatestNotifyAccountingAmount, getModifiedSaveFields, isPersistableDepositRefundAmount, pickSaveFieldValues, syncNotifyPm, syncRefundNotifyAccounting, syncResumeRefundRequest, syncSaveDepositAmount, validateModifiedSaveFields } from './sync.service'
import { TENANT_PROJECT_DEPOSIT_SYNC_ACTION } from './sync'

const REFUND_SAVE_FIELDS = ['isDirect', 'amount', 'payeeName', 'address', 'creditTo']

const REFUND_SAVE_FIELD_VALIDATORS = {
  amount: { inputSelector: '.input-deducted-amount' },
  creditTo: { inputSelector: '.input-credit-to' },
  payeeName: { group: 'mailing' },
  address: { group: 'mailing' },
}

const REFUND_SAVE_VALIDATOR_GROUPS = {
  mailing: {
    when: context => !context.isDirect,
    inputSelector: '.payee-name, .mailing-address',
  },
}

export default {
  components: {
    InputField,
    TextField,
    Modal,
    RequestRefundConfirmModal,
  },
  props: {
    canUpdate: Boolean,
    canNotifyAccounting: Boolean,
  },
  setup () {
    const { proxy } = getCurrentInstance()
    const { open, modal: confirmRef } = useRefModal()
    const finalDocsLength = useFinalDocLength()
    const { currentTenantProject, refund, deposit, isNormalAccount, isMainContractor } = useStoreGetters('tenantProject', ['currentTenantProject', 'refund', 'isNormalAccount', 'isMainContractor', 'deposit'])
    const { currentUser } = useStoreGetters('user', ['currentUser'])
    const requestIndex = computed(() => {
      const histories = unref(refund).actionHistory
      return histories.findIndex(h => h.actionType === DEPOSIT_HISTORY_TYPE.refundRequest)
    })
    const resumeIndex = computed(() => {
      const histories = unref(refund).actionHistory
      return histories.findIndex(h => h.actionType === DEPOSIT_HISTORY_TYPE.resumeRefundRequest)
    })
    const canResumeRefundRequest = computed(() => {
      return aclHelper.getAccess(tmsPermsTypes.project.resumeDeposit)
    })
    const canChangeRefundRequest = computed(() => unref(resumeIndex) !== -1 && unref(requestIndex) > unref(resumeIndex))
    const requestToRefundModal = async () => {
      if (proxy.validate()) {
        if (!unref(isExemptedFinalDoc) && unref(finalDocsLength) === 0) {
          open()
        } else {
          requestToRefund()
        }
      }
    }
    const requestToRefund = async () => {
      if (proxy.validateAmountBeforeSave && !proxy.validateAmountBeforeSave()) {
        return
      }
      formUtils.resetDirty(FORM_SRC_PROJECT_CONTROL)
      const result = await proxy.uploadRefundInfo(DEPOSIT_HISTORY_TYPE.refundRequest)
      if (!result) {
        return
      }
      await sendEmail(EmailTypes.tenantProjects.requestRefund)
      proxy.cancelChangeRefundRequest()
    }
    const resumeRefundRequest = async () => {
      await syncResumeRefundRequest({
        validate: proxy.validateAmountBeforeSave,
        uploadRefundInfo: proxy.uploadRefundInfo,
        tenantProjectId: proxy.tenantProjectId,
      })
    }
    const isHistoricalFinalDoc = useFinalDocStatus(FINAL_DOC_STATUS.HISTORICAL)
    const isExemptedFinalDoc = useFinalDocStatus(FINAL_DOC_STATUS.EXEMPTED)
    const isCompletedTProject = useIsCurrentTenantProjectStatus(tenantProjectStatus.COMPLETED)
    const isWithDrawTProject = useIsCurrentTenantProjectStatus(tenantProjectStatus.WITHDRAWN)
    const isCancelTProject = useIsCurrentTenantProjectStatus(tenantProjectStatus.CANCELLED)
    const notAvaliableFinalDoc = computed(() => {
      return unref(isHistoricalFinalDoc) && (unref(isCompletedTProject) || unref(isWithDrawTProject) || unref(isCancelTProject))
    })
    const disabledChangeRefundRequest = computed(() => {
      return !unref(notAvaliableFinalDoc) && !unref(canChangeRefundRequest)
    })

    const isTenancyAccount = computed(() => {
      const tenancyAccounts = lodash.get(
        unref(currentTenantProject), 'tenancy.accounts', [],
      )
      return tenancyAccounts.some(account => account.id === currentUser.id)
    })
    const isTenancyOrNormalAccount = computed(() => {
      const actionHistory = lodash.get(unref(deposit), 'actionHistory') || []
      const hasAllowedConToRefund = lodash.findIndex(
        actionHistory, ['actionType', DEPOSIT_HISTORY_TYPE.allowContractorRefund],
      ) > -1
      console.log(isMainContractor)
      const isAllowedContractor = unref(isMainContractor) && hasAllowedConToRefund
      return unref(isNormalAccount) || unref(isTenancyAccount) || isAllowedContractor
    })
    return {
      isTenancyOrNormalAccount,
      disabledChangeRefundRequest,
      notAvaliableFinalDoc,
      confirmRef,
      requestToRefund,
      requestToRefundModal,
      resumeRefundRequest,
      canResumeRefundRequest,
      canChangeRefundRequest,
      resumeIndex,
      requestIndex,
    }
  },
  data () {
    return {
      amount: '',
      creditTo: '',
      regex,
      isEditingAmount: false,
      isDirect: true,
      payeeName: '',
      address: '',
      sourceId: '',
      tenantProjectId: '',
      accountingEmail: '',
      requested: false,
      reEditAble: false,
      hintValue: this.$t('hint.inputTip.default'),
      hintEmail: this.$t('hint.inputTip.email'),
      hintString: this.$t('hint.inputTip.string'),
      FORM_SRC_PROJECT_CONTROL,
    }
  },
  computed: {
    ...mapGetters('user', ['isTenant', 'currentUser', 'isEngineer']),
    ...mapGetters('tenantProject', ['currentTenantProject', 'refund', 'deposit', 'isNormalAccount']),
    ...mapGetters('ccd', ['currentTenancy']),
    currency () {
      return this.$globalProps.getCurrency()
    },
    isAmountZero () {
      return parseFloat(this.amount) === 0
    },
    depositAmount () {
      return getLatestNotifyAccountingAmount(this.deposit)
    },
    defuctedAmount () {
      return CurrencyFormatter.format(getLatestNotifyAccountingAmount(this.deposit) - this.amount, 'USD')
    },
    finalDocs () {
      return lodash.get(this.currentTenantProject, 'finalDocument') || {}
    },
    isFinalDocsValid () {
      const enableStatus = [FINAL_DOC_STATUS.EXEMPTED, FINAL_DOC_STATUS.COMPLETED, FINAL_DOC_STATUS.HISTORICAL]
      return enableStatus.includes(this.finalDocs.status)
    },

    showRequestedBy () {
      const displayName = lodash.get(this, 'refund.requestor.displayName')
      const id = lodash.get(this, 'refund.requestor.id')
      const currentTenancyAccounts = lodash.get(this.currentTenancy, 'accounts', [])
      return replaceDisplayName(displayName, id, currentTenancyAccounts)
    },
    showRequestedAt () {
      return dateUtil.formatDate(lodash.get(this, 'refund.requestedAt'), true)
    },
    showAmount () {
      return CurrencyFormatter.format(this.amount, 'USD')
    },
    isNotifiedPM () {
      return !!lodash.get(this, 'notifyPMInfo.time')
    },
    notifyPMInfo () {
      return this.getNotifyInfo(DEPOSIT_HISTORY_TYPE.notifyPM)
    },
    notifyAccountingInfo () {
      return this.getNotifyInfo(DEPOSIT_HISTORY_TYPE.notifyAccounting)
    },
    resumeRefundRequestInfo () {
      return this.getNotifyInfo(DEPOSIT_HISTORY_TYPE.resumeRefundRequest)
    },
    isUserNotifyAccounting () {
      const actionHistory = lodash.get(this.deposit, 'actionHistory', [])
      return actionHistory.some((item) => item.actionType === DEPOSIT_HISTORY_TYPE.notifyAccounting)
    },
    refundAmountError () {
      const strVal = String(this.amount == null ? '' : this.amount).trim()
      if (!strVal || !regex.decimal.test(strVal)) {
        return false
      }
      return getLatestNotifyAccountingAmount(this.deposit) - parseFloat(strVal) < 0
    },
    isBegin () {
      return this.deposit && this.deposit.updatedAt
    },
  },
  watch: {
    refund: {
      handler () {
        const data = lodash.cloneDeep(this.refund)
        this.amount = data.amount
        this.isDirect = data.isDirect
        this.payeeName = data.payeeName
        this.address = data.address
        this.creditTo = data.creditTo
        this.sourceId = data.sourceId
        this.requested = lodash.get(this, 'refund.requestedAt')
        this.showFieldValidationErrors()
      },
      immediate: true,
    },
  },
  async mounted () {
    this.tenantProjectId = this.$route.params.id
    await this.loadTenantProject(this.tenantProjectId)
    this.showFieldValidationErrors()
  },
  methods: {
    ...mapActions('tenantProject', ['loadTenantProject']),
    updateAmount (val) {
      this.amount = val
      if (parseFloat(this.amount) === 0) {
        this.creditTo = ''
      }
      this.scheduleDirtyStateCheck()
    },
    showFieldValidationErrors () {
      this.$nextTick(() => {
        // Tab selection via EventBus runs after ~100ms; wait so inputs are visible before showing tooltips.
        setTimeout(() => {
          if (!(this.deposit && this.deposit.updatedAt) || !this.isEngineer) {
            return
          }
          validateProjectControlFieldsOnLoad('.refund-user-input')
        }, 150)
      })
    },
    validateRefundAmountInput (val) {
      const strVal = String(val == null ? '' : val).trim()
      if (!strVal || !regex.decimal.test(strVal)) {
        return false
      }
      return getLatestNotifyAccountingAmount(this.deposit) - parseFloat(strVal) >= 0
    },
    updateCreditTo (val) {
      this.creditTo = val
      this.scheduleDirtyStateCheck()
    },
    updatePayeeName (val) {
      this.payeeName = val
      this.scheduleDirtyStateCheck()
    },
    updateAddress (val) {
      this.address = val
      this.scheduleDirtyStateCheck()
    },
    changePayeeType () {
      this.address = ''
      this.payeeName = ''
      fusionInputCheckUtil.resetInputFiled('.tenant-edit-area input')
      this.scheduleDirtyStateCheck()
    },
    scheduleDirtyStateCheck () {
      this.$nextTick(() => {
        window.setTimeout(() => {
          this.$emit('dirty-state-change')
        }, 0)
      })
    },
    async uploadRefundInfo (type, { extraRequest = {}, requestHandler = tenantProjectApi.updateDepositRefund } = {}) {
      const request = {
        isDirect: this.isDirect,
        amount: this.amount || 0,
        payeeName: this.payeeName,
        address: this.address,
        creditTo: this.creditTo,
        updatedBy: lodash.get(this, 'refund.updator.id'),
        requestedAt: type === 'refundRequest' ? new Date() : this.requestedAt,
        requestedBy: type === 'refundRequest' ? this.currentUser.id : this.requestedBy,
      }
      if (this.isModified() && this.isEngineer) {
        request.updatedAt = new Date()
        request.updatedBy = this.currentUser.id
      }
      const actionHistory = lodash.cloneDeep(this.refund.actionHistory)
      actionHistory.unshift({
        actionType: type,
        user: {
          id: this.currentUser.id,
          username: this.currentUser.username,
          displayName: this.currentUser.displayName,
        },
        isNewRec: true,
      })
      request.actionHistory = actionHistory

      const result = await requestHandler(this.refund.id, {
        ...request,
        ...extraRequest,
      })
      if (!result) {
        return null
      }
      await this.loadTenantProject(this.tenantProjectId)
      return result
    },
    async saveAndContinue () {
      const result = await syncSaveDepositAmount({
        validate: this.validateAmountBeforeSave,
        uploadSaveInfo: this.uploadSaveAndContinueInfo,
        hasDirtySaveFields: () => this.hasDirtySaveFields(),
        resetDirty: () => formUtils.resetDirty(FORM_SRC_PROJECT_CONTROL),
      })
      if (result) {
        this.isEditingAmount = false
      }
      return result
    },
    getSaveFieldValues () {
      return pickSaveFieldValues(REFUND_SAVE_FIELDS, this, {
        amount: amount => amount || 0,
      })
    },
    hasDirtySaveFields () {
      return this.getModifiedSaveFieldsForSave().length > 0
    },
    getModifiedSaveFieldsForSave () {
      return getModifiedSaveFields(this.refund, this.getSaveFieldValues(), REFUND_SAVE_FIELDS)
    },
    validateSaveAndContinue () {
      if (this.isTenant) {
        return true
      }
      if (!this.validateAmountBeforeSave()) {
        return false
      }
      return validateModifiedSaveFields({
        record: this.refund,
        local: this.getSaveFieldValues(),
        fields: REFUND_SAVE_FIELDS,
        fieldValidators: REFUND_SAVE_FIELD_VALIDATORS,
        groupValidators: REFUND_SAVE_VALIDATOR_GROUPS,
        context: this,
      })
    },
    async uploadSaveAndContinueInfo ({ skipReload = false } = {}) {
      const request = buildDirtyFieldSaveRequest({
        record: this.refund,
        local: this.getSaveFieldValues(),
        fields: REFUND_SAVE_FIELDS,
        currentUser: this.currentUser,
        actionType: DEPOSIT_HISTORY_TYPE.saveDepositAmount,
      })
      if (!request) {
        return true
      }
      const result = await tenantProjectApi.updateDepositRefund(this.refund.id, request)
      if (!result) {
        return null
      }
      if (!skipReload) {
        await this.loadTenantProject(this.tenantProjectId)
      }
      return result
    },
    async notifyPM () {
      this.isEditingAmount = false
      await syncNotifyPm({
        validate: this.validate,
        uploadInfo: this.uploadRefundInfo,
        notifyType: DEPOSIT_HISTORY_TYPE.notifyPM,
        resetDirty: () => formUtils.resetDirty(FORM_SRC_PROJECT_CONTROL),
        sendEmail,
        emailType: EmailTypes['tenantProjects'].refundNotifyPM,
        tenantProjectId: this.tenantProjectId,
        syncAction: TENANT_PROJECT_DEPOSIT_SYNC_ACTION.refundNotifyPM,
      })
    },
    isModified () {
      return ['payeeName', 'address', 'amount', 'creditTo', 'isDirect'].some(attr => this.refund[attr] !== this[attr])
    },
    validate () {
      const targetArea = this.isTenant ? '.tenant-edit-area' : '.refund-user-input'
      if (!this.isTenant || !this.isDirect) {
        fusionInputCheckUtil.validateAllFields({allowEmpty: 'none'}, targetArea)
      }
      if (!this.validateAmountBeforeSave()) {
        return false
      }
      return fusionInputCheckUtil.isAllFieldsValid(targetArea) && !this.refundAmountError
    },
    validateAmountBeforeSave () {
      if (this.isTenant || isPersistableDepositRefundAmount(this.amount)) {
        return true
      }
      fusionInputCheckUtil.validateAllFields({allowEmpty: 'none'}, '.input-deducted-amount')
      notification.error(this.$t('tenantProjects.correctAmountBeforeSave'))
      return false
    },
    updateAccountingEmail (val) {
      this.accountingEmail = val
    },
    async openModal () {
      if (this.validate()) {
        this.accountingEmail = await getRegionEnvsByCode('mail.accountingMail')
        const isEmptyObject = typeof this.accountingEmail === 'object' && !Object.keys(this.accountingEmail).length
        if (!this.accountingEmail || isEmptyObject) {
          notification.error(i18n.t('error.getAccountingEmail.system'))
          return
        }
        this.$refs['refund-input-modal'].open()
      }
    },
    closeModal () {
      this.$refs['refund-input-modal'].close()
      fusionInputCheckUtil.resetInputFiled('.refund-input-accounting-email input')
    },
    validateAccounting () {
      fusionInputCheckUtil.validateAllFields({allowEmpty: 'none'}, '.refund-input-accounting-email')
      return fusionInputCheckUtil.isAllFieldsValid('.refund-input-accounting-email')
    },
    async sendEmailToAccounting () {
      this.isEditingAmount = false
      if (!this.validateAmountBeforeSave()) {
        return
      }
      const emailPayload = buildRefundNotifyAccountingEmailPayload({
        deposit: this.deposit,
        amount: this.amount,
        creditTo: this.creditTo,
        isDirect: this.isDirect,
        payeeName: this.payeeName,
        address: this.address,
        email: this.accountingEmail,
      })
      await syncRefundNotifyAccounting({
        validateAccounting: this.validateAccounting,
        buildEmails,
        uploadRefundInfo: this.uploadRefundInfo,
        resetDirty: () => formUtils.resetDirty(FORM_SRC_PROJECT_CONTROL),
        closeModal: this.closeModal,
        tenantProjectId: this.tenantProjectId,
        emailType: EmailTypes['tenantProjects'].refundNotifyAccounting,
        requestHandler: tenantProjectApi.notifyAccountingDepositRefund,
        email: this.accountingEmail,
        emailPayload,
      })
    },
    changeRefundRequest () {
      this.reEditAble = true
    },
    cancelChangeRefundRequest () {
      this.reEditAble = false
      const data = lodash.cloneDeep(this.refund)
      this.isDirect = data.isDirect
      this.payeeName = data.payeeName
      this.address = data.address
      this.scheduleDirtyStateCheck()
    },
    getNotifyInfo (type) {
      const actionHistory = lodash.get(this.refund, 'actionHistory', [])
      let info = ''
      for (let i = 0, len = actionHistory.length; i < len; i++) {
        if (actionHistory[i].actionType === type) {
          info = {
            by: actionHistory[i].user.displayName,
            time: dateUtil.formatDate(actionHistory[i].updatedAt, true),
          }
          break
        }
      }
      return info
    },
  },
}
</script>

<style lang='scss'>
.refund-deposit {
  position: relative;
  min-height: 125px;
  .subject-to-review {
    margin-top: 5px;
    margin-bottom: 10px;
    .vertical-middle {
      vertical-align: middle;
    }
  }
  label {
    margin-top: 0;
  }
  .refund-user-input {
    margin-bottom: 5px;
  }
  .input-field {
    display: inline-block;
    input {
      width: 100%;
    }
  }
  .input-credit-to-pencil {
    display: flex;
    align-items: center;
  }
  .input-credit-to {
    width: 350px;
    margin-right: 10px;
  }
  .payee-area {
    padding: 10px 20px 20px 20px;
    background: #f2f6f8;
    p {
      margin-top: 10px;
    }
    .header {
      font-weight: bold;
    }
    .header, .info {
      height: 25px;
      line-height: 25px;
      & > span:first-child {
        width: 200px;
        display: inline-block;
      }
    }
  }
  .payee-info {
    i.gray-font {
      display: inline-block;
      margin: 5px 0;
    }
    div {
      margin: 5px 0;
    }
  }
  .deducted-amount {
    margin-top: 5px;
    display: flex;
    align-items: center;
  }
  .deducted-amount, .credit-to {
    margin-bottom: 0.8rem;
  }
  .btns {
    position: absolute;
    font-size: 0;
    top: 0;
    right: 0;
    text-align: right;
    i {
      display: block;
      font-size: 12px;
    }
  }
  .fusion-input-check-is-invalid-input {
    border-color: none !important;
  }
  .tenant-edit-area {
    .input-field {
      display: block;
      width: 50%;
      input {
        width: 100%;
      }
    }
  }
  .internal {
    font-weight: normal;
  }
  .refund-view {
    p {
      margin-top: 10px;
    }
  }
  .error-highlight-input {
    input {
      border: 1px solid red;
      background: #f9ecea;
    }
  }
  .input-deducted-amount input {
    margin-bottom: 0;
    margin-right: 10px;
  }
  .deducted-amount-hint {
    margin-left: 10px;
    font-size: 12px;
    color: #878787;
    display: inline-block;
    height: 20px;
    font-style: italic;
  }
  .deposit-notify-info {
    margin-top: 6px;
  }
  .noBegin {
    opacity: 0.5;
  }
  .mailing-address, .payee-name {
    margin-top: 15px;
  }
  .request-refund-info.gray-font {
    display: inline-block;
    width: 310px;
    text-align: right;
  }
}
</style>
